import { useEffect } from 'react';

export function useCustomButtonColor({
  buttonRef,
  customButtonColorValues,
  customButtonActiveColor,
  customButtonHoverColor,
  customButtonTextActiveColor,
  customButtonTextHoverColor,
}) {
  const buttonColor = customButtonActiveColor || '#008254';
  const buttonTextColor = customButtonTextActiveColor || '#ffffff';
  const buttonHoverColor = customButtonHoverColor || '#006642';
  const buttonTextHoverColor = customButtonTextHoverColor || '#ffffff';

  useEffect(() => {
    if (buttonRef.current && customButtonColorValues) {
      buttonRef.current.style.setProperty(
        '--button-background-color',
        buttonColor
      );

      buttonRef.current.style.setProperty(
        '--button-hover-background-color',
        buttonHoverColor
      );

      buttonRef.current.style.setProperty(
        '--button-tex-color',
        buttonTextColor
      );

      buttonRef.current.style.setProperty(
        '--button-text-hover-color',
        buttonTextHoverColor
      );
    }
  }, [
    buttonColor,
    buttonHoverColor,
    buttonTextColor,
    buttonTextHoverColor,
    customButtonColorValues,
    buttonRef,
  ]);
}
